module.exports = __webpack_public_path__ + "img/64e8c7ea954e7b2e6f5d2138e7165b65.e1986130.jpg";